import { useState } from "react";
import { HelpCircle, Sparkles, Target, Grid3x3, Rabbit, PenTool } from "lucide-react";
import { SmartBuyerQuiz } from "@/components/games/SmartBuyerQuiz";
import { MythVsFact } from "@/components/games/MythVsFact";
import { EmiGuessGame } from "@/components/games/EmiGuessGame";
import { Game2048 } from "@/components/games/Game2048";
import { DreamRunner } from "@/components/games/DreamRunner";
import { DrawingCanvas } from "@/components/games/DrawingCanvas";

const GAMES = [
  { id: "quiz", label: "Smart Buyer Quiz", icon: HelpCircle },
  { id: "myth", label: "Myth vs Fact", icon: Sparkles },
  { id: "emi", label: "Guess the EMI", icon: Target },
  { id: "2048", label: "2048", icon: Grid3x3 },
  { id: "runner", label: "Dream Run", icon: Rabbit },
  { id: "draw", label: "Draw Your Home", icon: PenTool },
];

export default function Games() {
  const [active, setActive] = useState("quiz");

  return (
    <div className="pt-32">
      <div className="container-px mx-auto max-w-[1200px] pb-24">
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-cyan">Learn & Play</p>
        <h1 className="font-display text-5xl font-extrabold uppercase leading-none text-foreground md:text-8xl">Play to<br />learn.</h1>
        <p className="mt-6 max-w-xl text-muted-foreground">Better decisions come from practice. Test your knowledge, bust property myths, train your EMI intuition, beat a high score, and design your dream home.</p>

        <div className="mt-12 grid grid-cols-2 gap-px border border-border bg-border sm:grid-cols-3 md:grid-cols-6" data-testid="games-tabs">
          {GAMES.map((g) => (
            <button key={g.id} onClick={() => setActive(g.id)} data-testid={`game-tab-${g.id}`}
              className={`flex flex-col items-center gap-2 px-3 py-5 font-mono text-[11px] uppercase tracking-widest transition-colors
                ${active === g.id ? "bg-cyan text-white" : "bg-background text-muted-foreground hover:bg-card hover:text-foreground"}`}>
              <g.icon className="h-5 w-5" strokeWidth={1.5} />
              <span className="text-center leading-tight">{g.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-8">
          {active === "quiz" && <SmartBuyerQuiz />}
          {active === "myth" && <MythVsFact />}
          {active === "emi" && <EmiGuessGame />}
          {active === "2048" && <Game2048 />}
          {active === "runner" && <DreamRunner />}
          {active === "draw" && (
            <div>
              <p className="mb-6 max-w-2xl text-sm text-muted-foreground">Grab a brush and sketch your ideal home — floor plan, facade or dream layout. Save it and share it with Ayush when you book a consultation.</p>
              <DrawingCanvas />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
